import { useState } from 'react';
export function useSettingsContext() {
    var _a = useState(false), showRightMenu = _a[0], setShowRightMenu = _a[1];
    var _b = useState(false), showMobileMenu = _b[0], setShowMobileMenu = _b[1];
    var _c = useState(window.innerWidth > 1060), showFilters = _c[0], setShowFilters = _c[1];
    var _d = useState(window.innerWidth > 824), showChangelogMenu = _d[0], setShowChangelogMenu = _d[1];
    return {
        showRightMenu: showRightMenu,
        showMobileMenu: showMobileMenu,
        showFilters: showFilters,
        showChangelogMenu: showChangelogMenu,
        setShowRightMenu: setShowRightMenu,
        setShowMobileMenu: setShowMobileMenu,
        setShowFilters: setShowFilters,
        setShowChangelogMenu: setShowChangelogMenu,
    };
}
